// Secure profile fetcher
import type { SecureProfileResponse } from '@mrb91002/shared-types'

import { secureFetch, SECURE_API_BASE } from '../secure/helpers'

export async function fetchSecureProfile(screenName: string, idToken: string): Promise<SecureProfileResponse> {
  const url = `${SECURE_API_BASE}/profile/${encodeURIComponent(screenName)}`
  console.log('[PATTERNS] fetchSecureProfile:', { url, screenName, hasToken: !!idToken })
  const data = await secureFetch<SecureProfileResponse>(url, idToken, { method: 'GET' })
  console.log('[PATTERNS] fetchSecureProfile data:', {
    profileFound: !!data.profile,
    privatePatternCount: data.profile?.private_pattern_count,
    archivedPatternCount: data.profile?.archived_pattern_count,
    patternCount: data.published_pattern_displays?.length,
  })
  return data
}

// Self-mode secure profile fetch for the logged-in user. Resolves the caller's own
// profile from their identity token (no screen name required), so it can be called at
// login/session init before the screen name is known. Returns the secure response,
// including the optional `permissions` derived ban-state flags for the own-profile case.
export async function fetchOwnSecureProfile(idToken: string): Promise<SecureProfileResponse> {
  const url = `${SECURE_API_BASE}/profile?self=true`
  return secureFetch<SecureProfileResponse>(url, idToken, { method: 'GET' })
}
